// i18n (F-14): every visible string goes through t(). Industry terms stay in English in both languages.

import { EN, ZH_TW } from './strings';
import { SLOT_LABELS } from '../core/types';

export type Lang = 'zh-TW' | 'en';
const TABLES: Record<Lang, Record<string, string>> = { 'zh-TW': ZH_TW, en: EN };
let lang: Lang = 'zh-TW';
const listeners = new Set<() => void>();

export function getLang(): Lang {
  return lang;
}

export function setLang(l: Lang): void {
  if (l === lang) return;
  lang = l;
  document.documentElement.lang = l === 'zh-TW' ? 'zh-Hant' : 'en';
  for (const f of listeners) f();
}

export function onLangChange(f: () => void): () => void {
  listeners.add(f);
  return () => listeners.delete(f);
}

export function t(key: string, params?: Record<string, string | number>, forLang: Lang = lang): string {
  let s = TABLES[forLang][key] ?? TABLES['zh-TW'][key] ?? key;
  // Source ids in parameters are shown by their display names (B1 → B, B2 → C, B3 → D).
  const show = (v: string | number) => (typeof v === 'string' && v in SLOT_LABELS ? SLOT_LABELS[v as keyof typeof SLOT_LABELS] : String(v));
  if (params) s = s.replace(/\{(\w+)\}/g, (m, k: string) => (params[k] !== undefined ? show(params[k]) : m));
  return s;
}

export function hasKey(key: string): boolean {
  return key in ZH_TW;
}

/** Applies data-i18n / data-i18n-title / data-i18n-placeholder attributes under root. */
export function applyI18n(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-i18n]').forEach((el) => {
    el.textContent = t(el.dataset.i18n!);
  });
  root.querySelectorAll<HTMLElement>('[data-i18n-title]').forEach((el) => {
    el.title = t(el.dataset.i18nTitle!);
  });
  root.querySelectorAll<HTMLInputElement>('[data-i18n-placeholder]').forEach((el) => {
    el.placeholder = t(el.dataset.i18nPlaceholder!);
  });
}
